export default {
  setSubscription(state, payload) {
    return (state.subscriptions = payload);
  },
};
